import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getClienteProveedor, createClienteProveedor, updateClienteProveedorById, deleteClienteProveedorById, getUsuarios } from "../api";

const FilterTableClienteProveedor = () => {
  const [ClienteProveedor, setClienteProveedor] = useState([]);
  const [filteredClienteProveedor, setFilteredClienteProveedor] = useState([]);
  const [formData, setFormData] = useState({ id: 0, descripcion: "", id_usuario: "" });
  const [usuarios, setUsuarios] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");

    const fetchDropdownData = async () => {
      try {
        const [usuariosResponse] = await Promise.all([
          getUsuarios(),
        ]);
        setUsuarios(usuariosResponse.data);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };

  const fetchClienteProveedor = async () => {
    try {
      const response = await getClienteProveedor();
      setClienteProveedor(response.data);
      setFilteredClienteProveedor(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching  ubicacion:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchClienteProveedor();
    fetchDropdownData();
  }, []);

  useEffect(() => {
    if (filterText) {
      const filtered = ClienteProveedor.filter((ClienteProveedor) =>
        ClienteProveedor.descripcion.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredClienteProveedor(filtered);
    } else {
      setFilteredClienteProveedor(ClienteProveedor);
    }
  }, [filterText, ClienteProveedor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateClienteProveedorById(formData.id, { tipo: formData.tipo, id_usuario: formData.id_usuario, codigo_postal: formData.codigo_postal, razon_social: formData.razon_social, nombre_contacto: formData.nombre_contacto, telefono: formData.telefono, sitio_web: formData.sitio_web, calle: formData.calle, numero_ext: formData.numero_ext, numero_int: formData.numero_int, colonia: formData.colonia, ciudad: formData.ciudad, estado: formData.estado, regimen: formData.regimen, fecha_ultima_constancia: formData.fecha_ultima_constancia, rfc: formData.rfc });
        alert("ClienteProveedor actualizado con éxito.");
      } else {
        await createClienteProveedor(formData);
        alert("ClienteProveedor registrado con éxito.");
      }
      setFormData({ id: 0, descripcion: "" });
      setIsEditing(false);
      fetchClienteProveedor();
    } catch (error) {
      console.error("Error procesando el de ubicacion:", error);
    }
  };

  const handleEdit = (ClienteProveedor) => {
    setFormData(ClienteProveedor);
    setIsEditing(true);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, descripcion: "" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar este de ubicacion?")) {
      try {
        await deleteClienteProveedorById(id);
        alert(" de ClienteProveedor eliminado con éxito.");
        fetchClienteProveedor();
      } catch (error) {
        console.error("Error eliminando el de ubicacion:", error);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Cliente o Proveedor" : "Agregar Cliente o Proveedor"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            disabled={isEditing}
            hidden
          />
        </div>
        <div className="input-group">
          <label className="label2">Razon Social</label>
          <input
            type="text"
            name="razon_social"
            value={formData.razon_social}
            onChange={handleChange}
            className="input-form-1"
          />
          <label className="label2">Usuario</label>
          <select
            name="id_usuario"
            value={formData.id_usuario}
            onChange={handleChange}
            className="input-form-1"
          >
            {usuarios.map((usuario) => (
              <option key={usuario.id} value={usuario.id}>
                {usuario.username}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
        <label className="label2">Tipo ClienteProveedor</label>
          <select
            name="tipo"
            value={formData.tipo}
            onChange={handleChange}
            className="input-form-1"
          >
              <option key="cliente" value="cliente">Cliente</option>
              <option key="proveedor" value="proveedor">Proveedor</option>
          </select>

          <label className="label2">Nombre Contacto</label>
          <input
            type="text"
            name="nombre_contacto"
            value={formData.nombre_contacto}
            onChange={handleChange}
            className="input-form-1"
          />
        </div>

        <div className="input-group">
        <label className="label2">Telefono</label>
        <input
            type="text"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            className="input-form-1"
          />

          <label className="label2">Sitio Web</label>
          <input
            type="text"
            name="sitio_web"
            value={formData.sitio_web}
            onChange={handleChange}
            className="input-form-1"
          />
        </div>

        <div className="input-group">
        <label className="label2">Calle</label>
        <input
            type="text"
            name="calle"
            value={formData.calle}
            onChange={handleChange}
            className="input-form-1"
          />

          <label className="label2">Colonia</label>
          <input
            type="text"
            name="colonia"
            value={formData.colonia}
            onChange={handleChange}
            className="input-form-1"
          />
        </div>

        <div className="input-group">
        <label className="label2">Numero Ext</label>
        <input
            type="text"
            name="numero_ext"
            value={formData.numero_ext}
            onChange={handleChange}
            className="input-form-1"
          />

          <label className="label2">Numero Int</label>
          <input
            type="text"
            name="numero_int"
            value={formData.numero_int}
            onChange={handleChange}
            className="input-form-1"
          />
        </div>

        <div className="input-group">

          <label className="label2">Ciudad</label>
          <input
            type="text"
            name="ciudad"
            value={formData.ciudad}
            onChange={handleChange}
            className="input-form-1"
          />
        <label className="label2">Estado</label>
        <input
            type="text"
            name="estado"
            value={formData.estado}
            onChange={handleChange}
            className="input-form-1"
          />
        </div>

        <div className="input-group">
          <label className="label2">Regimen</label>
          <input
            type="text"
            name="regimen"
            value={formData.regimen}
            onChange={handleChange}
            className="input-form-1"
          />
          <label className="label2">Codigo Postal</label>
          <input
            type="text"
            name="codigo_postal"
            value={formData.codigo_postal}
            onChange={handleChange}
            className="input-form-1"
          />
        </div>

        <div className="input-group">
        <label className="label2">RFC</label>
        <input
            type="text"
            name="rfc"
            value={formData.rfc}
            onChange={handleChange}
            className="input-form-1"
          />

          <label className="label2">Fecha Ultima Constancia</label>
          <input
            type="date"
            name="fecha_ultima_constancia"
            value={formData.fecha_ultima_constancia}
            onChange={handleChange}
            className="input-form-1"
          />
        </div>

        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <hr />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por descripción..."
          className="input2"
        />
      </div>
      {filteredClienteProveedor.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th colSpan="2"><center>Acciones</center></th>
              <th>ID</th>
              <th>Tipo</th>
              <th>Razon Social</th>
              <th>RFC</th>
              <th>Nombre Contacto</th>
              <th>Telefono</th>
              <th>Sitio Web</th>
              <th>Calle</th>
              <th>Numero Ext</th>
              <th>Numero int</th>
              <th>Colonia</th>
              <th>Ciudad</th>
              <th>Estado</th>
              <th>Regimen</th>
              <th>Fecha de Constancia</th>
            </tr>
          </thead>
          <tbody>
            {filteredClienteProveedor.map((ClienteProveedor) => (
              <tr key={ClienteProveedor.id}>
                <td>
                  <button onClick={() => handleEdit(ClienteProveedor)} className="button-table-blue">
                    Editar
                  </button>
                </td><td>
                  <button onClick={() => handleDelete(ClienteProveedor.id)} className="button-table-red">
                    Borrar
                  </button>
                </td>
                <td>{ClienteProveedor.id}</td>
                <td>{ClienteProveedor.tipo}</td>
                <td>{ClienteProveedor.razon_social}</td>
                <td>{ClienteProveedor.rfc}</td>
                <td>{ClienteProveedor.nombre_contacto}</td>
                <td>{ClienteProveedor.telefono}</td>
                <td>{ClienteProveedor.sitio_web}</td>
                <td>{ClienteProveedor.calle}</td>
                <td>{ClienteProveedor.numero_ext}</td>
                <td>{ClienteProveedor.numero_int}</td>
                <td>{ClienteProveedor.colonia}</td>
                <td>{ClienteProveedor.ciudad}</td>
                <td>{ClienteProveedor.estado}</td>
                <td>{ClienteProveedor.regimen}</td>
                <td>{ClienteProveedor.fecha_ultima_constancia}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

FilterTableClienteProveedor.propTypes = {
  ubicacion: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default FilterTableClienteProveedor;
